import "vant/es/overlay/style";
import _Overlay from "vant/es/overlay";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
Vue.use(_Overlay);

/**
 * 通知权限引导弹窗（Modal）
 * 底层使用 Vant van-overlay 实现遮罩，增强可扩展性
 * 适用场景：用户许愿、缺货登记
 *
 * 使用方式：
 * <NotificationGuideModal
 *   :visible="showNotificationModal"
 *   title="已标记想看，开启通知"
 *   subtitle="第一时间获取TA的演出动态"
 *   @confirm="onGuideConfirm"
 *   @cancel="onGuideCancel"
 *   @close="onGuideClose"
 * />
 *
 * 事件：
 * - confirm：点击「去开启」（不触发冷却，跳转设置页）
 * - cancel：点击「下次再说」（触发冷却）
 * - close：点击关闭按钮「×」（触发冷却）
 */
export default {
  name: 'NotificationGuideModal',
  components: {
    'van-overlay': _Overlay
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '开启通知'
    },
    subtitle: {
      type: String,
      default: '获取演出开票、开演等关键消息'
    },
    confirmText: {
      type: String,
      default: '去开启'
    },
    cancelText: {
      type: String,
      default: '下次再说'
    },
    // 自定义弹窗顶部图标，可按场景替换
    // 许愿场景默认图片
    iconUrl: {
      type: String,
      default: 'https://p0.pipi.cn/mediaplus/fe_rock_web/e429583d4945c2fa46494819fa6d85e618c88.png?imageMogr2/thumbnail/2500x2500%3E'
    }
  },
  methods: {
    onConfirm: function onConfirm() {
      this.$emit('confirm');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onClose: function onClose() {
      this.$emit('close');
    }
  }
};